/* eslint-disable react/jsx-pascal-case */
import {FC, useState, useEffect} from 'react'
import {PageTitle, PageLink} from '../../../_metronic/layout/core'
import {DataRoomHeader} from './components/header/DataRoomHeader'
import {KTCard} from '../../../_metronic/helpers'
import {Data_room} from './Data_room'
import {useAuth} from '../../modules/auth'
import {useLocation} from 'react-router-dom'
import useAuditContext from 'app/Hooks/useAuditContext'

const usersBreadcrumbs: Array<PageLink> = [
  {
    title: 'Dashboard',
    path: '/dashboard',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]
type FileItemType = {
  id?: string
  name: string
  isFolder: boolean
  fileSize: number
  contentType: string | undefined
  timeCreated: string
  isChecked?: boolean
  tenantId?: string
  uid?: string
  additionalData?: any
  downloadUrl?: string
  folderName: string
  subFolder: string
  fName: string
  fname?: string
  is_folder: boolean
}

const DataRoomWrapper: FC = () => {
  const [value, setData] = useState(false)
  const [subFolderClicked, setSubFolderClicked] = useState(false)
  const {currentUser} = useAuth()
  const [folderPath, setFolderPath] = useState(`/tenants/${currentUser?.tenantId}/dataroom/`)
  const [created, setFolderFileCreated] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')
  const [folderId, setFolderId] = useState('')
  const [selectedItems, setSelectedItems] = useState<FileItemType[]>([])
  const location = useLocation();
  const {currentAuditContext} = useAuditContext()

  const handleSelectionChange = (items: FileItemType[]) => {
    setSelectedItems(items)
  }

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const folderName = params.get('folderName');
    if (folderName) {
      setSearchTerm(folderName);
      handleSearchTermChange(folderName);
    }
  }, [location.search]);

  const onNewFolderClicked = () => {
    setData(true)
  }

  const updateData = () => {
    setData(!value)

    setFolderFileCreated(!created)
  }

  const onSubFolderClicked = (item) => {
    const tenantId = currentUser?.tenantId || ''
    setFolderPath(`/tenants/${tenantId}/dataroom/${item.folder_name}/`)
    setFolderId(item.id)
    setSubFolderClicked(false)
  }

  const onFileUploaded = () => {
    setFolderFileCreated(!created)
  }
  const handleSearchTermChange = (term) => {
    setSearchTerm(term)
  }

  return (
    <>
      <PageTitle
        icon='DataRoomIcon.svg'
        title='Data Room'
        // desc={`${totalSize} MB Used of 15 GB`}
        desc='Store and share evidences for your audits'
        breadcrumbs={usersBreadcrumbs}
      >
        Data Room
      </PageTitle>
      <KTCard>
        <DataRoomHeader
          onHeaderAction={onNewFolderClicked}
          subFoldderClicked={subFolderClicked}
          folderPath={folderPath}
          folderId={folderId}
          onFlieFolderCreated={onFileUploaded}
          onSearchTermChange={handleSearchTermChange}
          selectedItems={selectedItems}
          searchTerm={searchTerm}
          setSearchTerm={setSearchTerm}
          currentAuditContext={currentAuditContext}
        />
        {/* <DataRoom className='mb-5 mb-xl-8' isNewFolder={value} onFolderCreatedOrCancel={updateData} onSubFolderClicked={onSubFolderClicked} folderPath={folderPath} fileFolderCreated = {created}  searchTerm={searchTerm}/> */}
        <Data_room
          className='mb-5 mb-xl-8'
          isNewFolder={value}
          onFolderCreatedOrCancel={updateData}
          onSubFolderClicked={onSubFolderClicked}
          folderPath={folderPath}
          folderId={folderId}
          fileFolderCreated={created}
          searchTerm={searchTerm}
          onSelectionChange={handleSelectionChange}
        />
      </KTCard>
    </>
  )
}

export default DataRoomWrapper
